import { List } from 'immutable';
import { listFromOption, Option, Fun, none, some } from "widgets-for-react"

export type FieldCastingValidator<field> =
  field extends boolean ? { kind: "boolean", customValidationLogic?: Fun<field, boolean> }
  : field extends string ? { kind: "string", customValidationLogic?: Fun<field, boolean> }
  : field extends number ? { kind: "number", customValidationLogic?: Fun<field, boolean> }
  : field extends Array<infer entity> ? {
    kind: "array",
    elementValidator: TypeCastingValidator<entity, keyof entity>, customValidationLogic?: Fun<entity, boolean>
  }
  : field extends Object ? {
    kind: "object",
    fieldsValidator: TypeCastingValidator<field, keyof field>, customValidationLogic?: Fun<field, boolean | undefined>
  }
  : { kind: "unsupported" }


export type TypeCastingValidator<entity, fieldKeys extends (keyof entity) = keyof entity> =
  {
    [fieldKey in fieldKeys]: FieldCastingValidator<entity[fieldKey]>
  }

export type UnionCase<T, Kind extends keyof T, CaseName extends string> = T & { [k in Kind]:CaseName }

export const canSafelyCastAny = <entity,>(validators: Array<TypeCastingValidator<entity, any>>, valueToValidate: any, onError?: (fieldValidatorKey: any, valueToValidate: any) => void)
  : Option<entity> => {
  return List(validators.map(validator => canSafelyCast(validator, valueToValidate, false, onError)))
          .reduce((x,y) => x.kind == "r" ? x : y)
}

export const canSafelyCast = <entity,>(validator: TypeCastingValidator<entity, any>, valueToValidate: any, debug:boolean=false, onError?: (fieldValidatorKey: any, valueToValidate: any) => void)
  : Option<entity> => {
  const validatorRaw = validator as any
  // console.log("Validating", validatorRaw, valueToValidate)
  if (validatorRaw.kind == "boolean" || validatorRaw.kind == "number" || validatorRaw.kind == "string") {
    const customValidationLogic = validatorRaw.customValidationLogic
    if (validatorRaw.kind != typeof valueToValidate || (customValidationLogic != undefined && customValidationLogic(valueToValidate) == false)) {
      onError ? onError(validatorRaw, valueToValidate) : null
      console.error(`Error in field ${JSON.stringify(validatorRaw)} when parsing ${JSON.stringify(valueToValidate)}`)
      return none()
    }
    return some(valueToValidate as entity)
  }
  if (debug) console.log(Object.keys(validatorRaw))
  Object.keys(validatorRaw).forEach(fieldValidatorKey => {
    const fieldValidator = validatorRaw[fieldValidatorKey]
    const customValidationLogic = (validatorRaw[fieldValidatorKey] as any).customValidationLogic
    if (fieldValidator.kind == "boolean" || fieldValidator.kind == "number" || fieldValidator.kind == "string") {
      if (fieldValidator.kind != typeof (valueToValidate[fieldValidatorKey]) ||
        (customValidationLogic != undefined && customValidationLogic(valueToValidate[fieldValidatorKey]) == false)) {
        onError ? onError(fieldValidatorKey, valueToValidate) : null
        console.error(`Error in field ${fieldValidatorKey} when parsing ${JSON.stringify(valueToValidate)}`)
        return none()
      }
    } else if (fieldValidator.kind == "unsupported") {
      onError ? onError(fieldValidatorKey, valueToValidate) : null
      console.error(`Unsupported field ${fieldValidatorKey} when parsing ${JSON.stringify(valueToValidate)}`)
      return none()
    } else if (fieldValidator.kind == "array") {
      const elementValidator = (fieldValidator as any).elementValidator
      const arrayToValidate = valueToValidate[fieldValidatorKey]
      if (
        List<unknown>(arrayToValidate).find(v =>
          canSafelyCast<unknown>(elementValidator, v).kind == "l" ||
          (customValidationLogic != undefined && customValidationLogic(v) == false)
        )) {
        onError ? onError(fieldValidatorKey, arrayToValidate) : null
        console.error(`Error in array ${fieldValidatorKey} when parsing ${JSON.stringify(valueToValidate)}`)
        return none()
      }
    } else if (fieldValidator.kind == "object") {
      const fieldsValidator = (fieldValidator as any).fieldsValidator
      if (customValidationLogic != undefined) {
        const customValidationResult = customValidationLogic(valueToValidate[fieldValidatorKey])
        if (customValidationResult != undefined) return customValidationResult
      }
      if(List<unknown>(Object.keys(valueToValidate[fieldValidatorKey])).find(k => {
        // if ((fieldsValidator as any)[k as any].customValidationLogic != undefined) {
        //   const customFieldValidationResult = ((fieldsValidator as any)[k as any].customValidationLogic((valueToValidate[fieldValidatorKey] as any)[k as any]))
        //   if (customFieldValidationResult != undefined) return customFieldValidationResult
        // }
        return (fieldsValidator as any)[k as any] == undefined ? false 
        : canSafelyCast<unknown>((fieldsValidator as any)[k as any], (valueToValidate[fieldValidatorKey] as any)[k as any]).kind == "l"
        
      }
      )) {
        onError ? onError(fieldValidatorKey, valueToValidate) : null
        console.error(`Error in object ${fieldValidatorKey} when parsing ${JSON.stringify(valueToValidate)}`)
        return none()
      }
    } else {
      console.error(`Unsupported field validator for key '${fieldValidatorKey}' of kind ${fieldValidator.kind} when parsing ${JSON.stringify(valueToValidate)}`)
      return none()
    }
  })
  return some(valueToValidate as entity)
}


